import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

export async function deleteMultipleMedia(picIds: number[] = [], vidIds: number[] = [], eventVaultId?: number) {
  const params = new URLSearchParams()

  if (picIds.length) {
    params.append("pics", picIds.toString())
  }

  if (vidIds.length) {
    params.append("vids", vidIds.toString())
  }

  const endpoint = `api/event/${eventVaultId}/media`

  return axios.delete(endpoint, { params })
}

interface UseDeleteMultipleMediaArgs {
  picIds: number[]
  vidIds: number[]
  eventVaultId: number
}

export function useDeleteMultipleMedia() {
  return useMutation({
    mutationFn: ({ picIds, vidIds, eventVaultId }: UseDeleteMultipleMediaArgs) => deleteMultipleMedia(picIds, vidIds, eventVaultId),
  })
}
